import { useState } from 'react';

export default function Hero() {
  const [isConnected, setIsConnected] = useState(false);

  return (
    <section className="relative min-h-screen flex items-center justify-start overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-cyan-600"></div>
      
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>

      <div className="relative z-10 px-24 max-w-7xl">
        <h1 className="text-8xl font-bold text-white leading-tight mb-16">
          Secure Your<br />
          Digital<br />
          Freedom
        </h1>
        
        <p className="text-xl text-white/80 mb-20 max-w-2xl leading-relaxed">
          Browse the internet with complete privacy and security.<br />
          Military-grade encryption protects your data from prying eyes.
        </p>
        
        <a href="#pricing" className="inline-flex items-center gap-4 px-12 py-5 bg-white text-gray-900 rounded-full text-lg font-semibold hover:shadow-2xl transition-all whitespace-nowrap cursor-pointer group">
          Start Protecting Now
          <i className="ri-arrow-right-line text-2xl group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>

      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 z-10">
        <div className="bg-white/10 backdrop-blur-md rounded-2xl px-8 py-6 flex items-center gap-6 border border-white/20">
          <div className="flex items-center gap-3">
            <div className={`w-3 h-3 rounded-full ${isConnected ? 'bg-green-400' : 'bg-red-400'} animate-pulse`}></div>
            <span className="text-white text-sm font-medium">{isConnected ? 'Connected' : 'Disconnected'}</span>
          </div>
          <button 
            onClick={() => setIsConnected(!isConnected)}
            className="px-6 py-2 bg-white/20 hover:bg-white/30 text-white rounded-lg text-sm transition-all whitespace-nowrap cursor-pointer"
          >
            {isConnected ? 'Disconnect' : 'Connect'}
          </button>
        </div>
      </div>
    </section>
  );
}